// Multi-org + department data layer.

import { supabase } from '@govern360/shared';

export async function myOrgs() {
  const { data, error } = await supabase.rpc('my_orgs');
  return { data: data || [], error };
}

// Switch the active org, then reload so every page + RLS re-scopes cleanly.
export async function switchOrg(tenantId) {
  const { error } = await supabase.rpc('set_active_org', { p_tenant_id: tenantId });
  if (error) return { error };
  // Full reload is the safest way to re-scope all in-memory state + caches.
  window.location.hash = '#dashboard';
  window.location.reload();
  return {};
}

export async function resetToHomeOrg() {
  const { error } = await supabase.rpc('reset_to_home_org');
  if (!error) { window.location.hash = '#dashboard'; window.location.reload(); }
  return { error };
}

export async function orgDepartments() {
  const { data, error } = await supabase.rpc('org_departments');
  return { data: (data || []).map((r) => r.department), error };
}
